import '@/lib/shopify-polyfill'
import { channelwill } from '@channelwill/sdk'

export const isEmbedded = () => {
  if (!window.shopify) return false
  return window.shopify.environment.embedded
}

interface ToastOptions {
  duration: number
  isError: boolean
  action: string
  onAction: () => void
  onDismiss: () => void
}
export const toast = {
  show: (message: string, opts?: Partial<ToastOptions>) => {
    if (!opts) {
      opts = {
        duration: 2000,
      }
    }
    if (isEmbedded() && shopify.toast) {
      return shopify.toast.show(message, opts)
    } else if (channelwill.isEmbedded()) {
      // channelwill 内嵌环境使用 channelwill 的 toast
      return channelwill.toast.show(message, opts)
    } else {
      return window.alert(message)
    }
  },
}
export const saveBar = {
  async hide(id: string) {
    if (isEmbedded() && shopify.saveBar) {
      return await shopify.saveBar.hide(id)
    } else {
      return true
    }
  },
}

const ShopifyBridge = {
  toast,
  saveBar,
}
export default ShopifyBridge
